export const COMMUNITY_MULTI_BRAND = [
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 2,
    x: 0,
    y: 0,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['MESSAGES_RECEIVED'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 2,
    x: 2,
    y: 0,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['REPLY_RATE'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 2,
    x: 4,
    y: 0,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['RESPONSE_TIME'],
    },
  },
  {
    h: 16,
    type: 'BAR_METRIC',
    w: 3,
    x: 0,
    y: 8,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['MESSAGES_RECEIVED'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 8,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['MESSAGES_RECEIVED'],
    },
  },
  {
    h: 16,
    type: 'BAR_METRIC',
    w: 3,
    x: 0,
    y: 24,
    meta: {
      aggregate_by: 'SENTIMENT',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['MESSAGES_RECEIVED'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 24,
    meta: {
      aggregate_by: 'CHANNEL',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['MESSAGES_RECEIVED'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 40,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['RESPONSE_TIME'],
    },
  },
  {
    h: 16,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 40,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'TWITTER', 'YOUTUBE'],
      community: {
        filters: {
          message_tag_ids: ['message_tag_ids'],
        },
      },
      metrics: ['REPLY_RATE'],
    },
  },
  {
    h: 20,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 56,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'INSTAGRAM',
      metrics: ['ORGANIC_COMMENTS'],
      content_tag_ids: ['content_tag_ids'],
      sort_order: 'DESC',
    },
  },
  {
    h: 20,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 96,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metrics: ['TOTAL_COMMENTS'],
      content_tag_ids: ['content_tag_ids'],
      sort_order: 'DESC',
    },
  },
  {
    h: 20,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 116,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_COMMENTS'],
      content_tag_ids: ['content_tag_ids'],
      sort_order: 'DESC',
    },
  },
  {
    h: 20,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 136,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TWITTER',
      metrics: ['QUOTE_TWEETS'],
      content_tag_ids: ['content_tag_ids'],
      sort_order: 'DESC',
    },
  },
  {
    h: 20,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 76,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'FACEBOOK',
      metrics: ['COMMENTS'],
      content_tag_ids: ['content_tag_ids'],
      sort_order: 'DESC',
    },
  },
];
